<script>
export default {
    props: ["initEmail", "passwordChangeUrl"],
    data: function () {
        return {
            email: this.initEmail,
            waitingServerResponse: false,
            errorResponse: false,
        };
    },
    methods: {
        change: function (event) {
            if (!this.waitingServerResponse) {
                this.waitingServerResponse = true;
                this.$http
                    .post(
                        this.passwordChangeUrl,
                        {
                            email: this.email,
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then((response) => {
                        // console.log(response);
                        this.errorResponse = false;
                    })
                    .catch((error) => {
                        // console.error(error);
                        this.errorResponse = true;
                    })
                    .finally(() => {
                        this.waitingServerResponse = false;
                        $("#changepw-modal").modal("show");
                    });
            }
        },
    },
};
</script>
